<script>
    export default {
        name: 'CollapseItem',
        data: () => {
            return {
                open: false,
                id: null,
                iframeSrc: null,
                imageData: {},
                slider: null,
                sliderIndex: 1
            }
        },
        props: {
            srcIframe: {
                default: '',
                type: String
            },
            imagesAmount: {
                default: '',
                type: String
            },
            sliderSpeed: {
                default: '',
                type: String
            }
        },
        beforeMount() {
        },
        mounted() {
            this.id = this._uid;
        },
        methods: {
            toggle(event) {
                if (event) {
                    event.preventDefault();
                }
                this.open = !this.open;
            },
            afterEnter(element) {
                element.style.height = `auto`;
            },
            enter(element) {
                const {
                    width
                } = getComputedStyle(element);

                element.style.width = width;
                element.style.position = `absolute`;
                element.style.visibility = `hidden`;
                element.style.height = `auto`;

                const {
                    height
                } = getComputedStyle(element);

                element.style.width = null;
                element.style.position = null;
                element.style.visibility = null;
                element.style.height = 0;

                // Force repaint to make sure the
                // animation is triggered correctly.
                getComputedStyle(element).height;

                setTimeout(() => {
                    element.style.height = height;
                });

                this.initSlider();
                this.iframeSrc = this.srcIframe;
            },
            leave(element) {
                const {
                    height
                } = getComputedStyle(element);

                element.style.height = height;

                // Force repaint to make sure the
                // animation is triggered correctly.
                getComputedStyle(element).height;

                setTimeout(() => {
                    element.style.height = 0;
                });
                this.destroySlider();
            },
            initSlider() {
                if (this.imagesAmount > 1) {
                    this.slider = setInterval(() => {
                        if (this.sliderIndex < this.imagesAmount) {
                            this.sliderIndex++;
                        } else {
                            this.sliderIndex = 1;
                        }
                    }, this.sliderSpeed);
                }
            },
            destroySlider() {
                if (this.imagesAmount > 1) {
                    clearInterval(this.slider)
                }
            }
        }
    };
</script>
